import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { allCards } from '../use';

const { registerReducer } = useStorymapStore();

export class CardCommentAdded extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'CardCommentAdded';

    public constructor(public id: string) {
        super(CardCommentAdded.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: CardCommentAdded): void => {
    const card = allCards.value.find((x) => x.id === action.id);

    if (card) {
        card.hasComment = true;
    }
};

//@ts-ignore
registerReducer(CardCommentAdded.ACTION_TYPE, reducer);
